export default __webpack_public_path__ + "static/media/Käfer-auf-Blatt.40b49f90.png";